import addNewEmployeeService from './EmployeeDirectory/EmployeesList/AddNewEmployee'
import { appService } from './appSlice'
import { attendanceReportService } from './TimeAndAttendance/AttendanceReport/attendanceReportSlice'
import { authenticationService } from './Login/authenticationSlice'
import { basicInformationService } from './MyProfile/BasicInfoTab/basicInformatiomSlice'
import { categoryService } from './MyProfile/Categories/categorySlice'
import { certificateListService } from './EmployeeDirectory/CertificatesList/certificatesListSlice'
import { certificateTypeService } from './EmployeeDirectory/CertificatesList/AddCertificateType/certificateTypeSlice'
import { employeeAssetsService } from './MyProfile/MyAssetsTab/employeeAssetsSlice'
import { employeeCertificateService } from './MyProfile/QualificationsTab/EmployeeCertifications/employeeCertificationSlice'
import { employeeDesignationListService } from './EmployeeDirectory/EmployeesList/AddNewEmployee/DesignationList/employeeDesignationListSlice'
import { employeeListService } from './EmployeeDirectory/EmployeesList/employeeListSlice'
import { employeeProjectsService } from './MyProfile/ProjectsTab/employeeProjectSlice'
import { employeeQualificationService } from './MyProfile/QualificationsTab/EmployeeQualifications/employeeQualificationSlice'
import { employeeReporteesService } from './MyProfile/ReporteesTab/employeeReporteesSlice'
import { employeeReviewsService } from './MyProfile/ReviewTab/employeeReviewsSlice'
import { employeeSkillServices } from './MyProfile/QualificationsTab/EmployeeSkills/employeeSkillSlice'
import { generalInformationService } from './MyProfile/GeneralTab/generalInformationSlice'
import { personalInfoService } from './MyProfile/PersonalInfoTab/personalInfoTabSlice'
import { profileHistoryService } from './MyProfile/ProfileHistory/profileHistorySlice'
import { qualificationCategoryService } from './MyProfile/QualificationsTab/QualificationCategoryList/employeeQualificationCategorySlice'
import { shiftConfigurationService } from './EmployeeDirectory/EmployeesList/AddNewEmployee/ShiftConfiguration/shiftConfigurationSlice'
import { skillService } from './MyProfile/Skills/skillSlice'
import { userAccessToFeaturesService } from './Settings/UserRolesConfiguration/userAccessToFeaturesSlice'
import { technologyService } from './EmployeeDirectory/EmployeesList/AddNewEmployee/getAllTechnologySlice'
import { employeeReportService } from './EmployeeDirectory/EmployeeReport/'
import { employeeDesigationReportService } from './EmployeeDirectory/EmployeeReport/EmployeeDesignationReport/employeeDesignationReportSlice'
import { visaListService } from './EmployeeDirectory/VisaList/visaListSlice'
import { EmployeeHandbookService } from './EmployeeHandbook/employeeHandbookSlice'
import { ShowHandbookService } from './EmployeeHandbook/showHandbookSlice'
import { newYearPopupService } from './Login/newYearPopupSlice'
import { employeeHandbookSettingService } from './EmployeeHandbook/HandbookSettings/employeeHandbookSettingSlice'
import { timeInOfficeReportService } from './TimeAndAttendance/TimeInOfficeReport/timeInOfficeReportSlice'
import { vpnAttendanceService } from './TimeAndAttendance/VpnAttendance/vpnAttendanceSlice'
import { employeeLeaveSettingsService } from './Settings/LeaveSettings/employeeLeaveSettingsSlice'
import { countryService } from './EmployeeDirectory/EmployeesList/AddNewEmployee/countriesSlice'
import { hiveActivityReportService } from './TimeAndAttendance/HiveActivityReport/hiveActivityReportSlice'
import { employeeMailConfigurationService } from './Settings/MailConfiguration/employeeMailConfigurationSlice'
import { addTemplateService } from './Settings/MailConfiguration/AddTemplate/addMailTemplateSlice'
import { employeeService } from './EmployeeDirectory/EmployeesList/EditEmployee'
import { employeeLeaveApplyServices } from './Leaves/ApplyLeave/employeeApplyLeaveSlice'
import { scheduledInterviewsService } from './Recruitment/ScheduledInterviews/scheduledInterviewsSlice'
import { mailTemplateTypeService } from './Settings/MailConfiguration/AddMailTemplateType/addMailTemplateTypeSlice'
import { myAttendanceService } from './TimeAndAttendance/MyAttendance/myAttendanceSlice'
import { leaveReportService } from './Leaves/LeaveReports/leaveReportSlice'
import { ticketReportService } from './Support/Report/ticketReportSlice'
import { clientsService } from './ProjectManagement/Clients/clientsSlice'
import { addNewClientService } from './ProjectManagement/Clients/AddClient/addNewClientSlice'
import { clientInformationService } from './ProjectManagement/Clients/ClientInformation/clientInformationSlice'
import { leaveSummaryService } from './Leaves/LeaveSummary/employeeLeaveSummarySlice'
import { myTicketsService } from './Support/MyTickets/myTicketsSlice'
import { ticketApprovalsService } from './Support/TicketApprovals/ticketApprovalsSlice'
import { createNewTicketService } from './Support/RaiseTicket/createNewTicketSlice'
import { jobVacanciesService } from './Dashboard/jobOpeningsSlice'
import { PendingInterviewCommentsService } from './Dashboard/scheduleInterviewListSlice'
import { birthdaysListService } from './Dashboard/birthdayListSlice'
import { anniversaryListService } from './Dashboard/serviceAnniversariesListSlice'
import { upcomingBirthdaysService } from './Dashboard/birthdayAnniversarySlice'
import { upcomingServiceAnniversaryService } from './Dashboard/serviceAnniversarySlice'
import { holidaysService } from './Dashboard/holidaysSlice'
import { earnedLeavesService } from './Dashboard/earnedLeavesSlice'
import { weeklyTimeInOfficeService } from './Dashboard/timeInOfficeSlice'
import { trainingsAndEventsService } from './Dashboard/trainingsAndEventsSlice'
import { provisionPeriodService } from './Dashboard/provisionPeriodSlice'
import { employeeAchievementsService } from './Dashboard/achievementsSlice'
import { updateTicketService } from './Support/TicketApprovals/UpdateTicket/updateTicketSlice'
import { bookingListService } from './ConferenceRoomBooking/BookingList/bookingListSlice'
import { eventTypeListService } from './ConferenceRoomBooking/NewEvent/EventTypeList/eventTypeListSlice'
import { employeeAllocationSliceService } from './ProjectManagement/EmployeeAllocation/employeeAllocationSlice'
import { addLocationListService } from './ConferenceRoomBooking/NewBooking/LocationList/locationListSlice'
import { newBookingService } from './ConferenceRoomBooking/NewBooking/newBookingSlice'
import { addTrackerListService } from './Support/RaiseTicket/TrackerList/trackerListSlice'
import { eventListService } from './ConferenceRoomBooking/EventList/eventListSlice'
import { employeeSearchService } from './Dashboard/searchEmployeeSlice'
import { assignTemplateService } from './Settings/Configurations/assignTemplateSlice'
import { ticketConfigurationService } from './Settings/TicketConfiguration/ticketConfigurationSlice'
import { allocateEmployeeService } from './ProjectManagement/AllocateEmployee/allocateEmployeeSlice'
import { appraisalCycleService } from './Settings/Configurations/appraisalConfigurationsSlice'
import { roomListService } from './ConferenceRoomBooking/NewBooking/RoomList/roomListSlice'
import { submitViewResignationServices } from './Separation/SubmitViewResignation/submitResignationSlice'
import { addConfigurationService } from './Settings/Configurations/AddConfiguration/addConfigurationSlice'
import { projectManagementService } from './ProjectManagement/Project/AddEditPraject/AddEditProjectSlice'
import { projectReportsService } from './ProjectManagement/Project/projectReportSlice'
import { newEventService } from './ConferenceRoomBooking/NewEvent/newEventSlice'
import { leaveApprovalsService } from './Leaves/LeaveApprovals/leaveApprovalsSlice'
import { itDeclarationFormService } from './Finance/ITDeclarationForm/itDeclarationFormSlice'
import { paySlipsService } from './Finance/Payslips/payslipsSlice'
import { insuranceService } from './Finance/Insurance/insuranceSlice'
import { panDetailService } from './Finance/PanDetails/panDetailsSlice'
import { bankDetailService } from './Finance/PanDetails/bankDetailsSlice'
import { resignationListService } from './Separation/ResignationList/resignationListSlice'
import { employeeAccountService } from './Finance/EmployeeAccounts/employeeAccountsSlice'
import { itDeclarationListService } from './Finance/ITDeclarationList/itDeclarationListSlice'
import { investmentCheckListService } from './Finance/InvestmentCheckList/investmentCheckListSlice'
import { payrollManagementService } from './Finance/PayrollManagement/PayrollManagementSlice'
import { achieverListService } from './Achievements/AchieverList/AchieverListSlice'
import { commonAchievementsService } from './Achievements/CommonAchievementsSlice'
import { projectCreationRequestService } from './ProjectManagement/ProjectCreationRequests/projectCreationRequestsSlice.'
import { addProjectCreationRequestService } from './ProjectManagement/ProjectCreationRequests/AddProjectCreationRequest/addProjectCreationRequestSlice'
import { addAchieverServices } from './Achievements/AddAchiever/AddAchieverSlice'
import { projectViewService } from './ProjectManagement/Project/ProjectView/projectViewSlice'
import { projectTimeLineService } from './ProjectManagement/Project/ProjectView/ProjectTimeLine/projectTimeLineSlice'
import { changeRequestService } from './ProjectManagement/Project/ProjectView/ChangeRequest/changeRequestSlice'
import { mileStoneService } from './ProjectManagement/Project/ProjectView/MileStone/mileStoneSlice'
import { invoicesService } from './ProjectManagement/Project/ProjectView/Invoices/invoicesSlice'
import { invoiceVersionsService } from './Invoicing/Invoices/InvoiceVersion/InvoiceVersionSlice'
import { projectTailoringService } from './ProjectManagement/Project/ProjectView/ProjectTailoring/projectTailoringSlice'
import { projectHiveActivityReportService } from './ProjectManagement/Project/ProjectView/ProjectTimeSheet/projectTimeSheetSlice'
import { projectProposalsService } from './ProjectManagement/Project/ProjectView/Proposals/projectProposalsSlice'
import { projectNotesService } from './ProjectManagement/Project/ProjectView/Notes/projectNotesSlice'
import { initiateCycleService } from './Settings/InitiateCycle/initiateCycleSlice'
import { myKRAsService } from './Performance/MyKRAs/myKRAsSlice'
import { nomineeListService } from './Achievements/NomineeList/NomineeListSlice'
import { addNomineeService } from './Achievements/AddNominee/AddNomineeSlice'
import { myReviewService } from './Performance/MyReview/myReviewSlice'
import { leadershipEnrollmentListService } from './Achievements/LeadershipEnrollmentList/LeadershipEnrollmentListSlice'
import { leadershipEnrollmentFormService } from './Achievements/LeadershipEnrollmentForm/LeadershipEnrollmentFormSlice'
import { pipListService } from './Performance/PIPList/pipListSlice'
import { reviewListServices } from './Performance/ReviewList/ReviewListSlice'
import { KRAService } from './Performance/KRA/KRASlice'
import { appraisalTemplateService } from './Performance/AppraisalTemplate/AppraisalTemplateSlice'
import { projectStatusService } from './ProjectManagement/Project/ProjectView/Status/projectStatusSlice'
import { processAreaService } from './Settings/ProcessArea/ProcessAreaSlice'
import { addNewAuditService } from './SQAAuditReport/addNewAuditSlice'
import { sqaAuditReportService } from './SQAAuditReport/sqaAuditReportSlice'
import { notificationService } from './Notifications/notificationSlice'
import { jobOpeningsService } from './Recruitment/JobOpenings/jobOpeningsSlice'
import { intervieweeDetailsService } from './Recruitment/IntervieweeDetails/IntervieweeDetailsSlice'
import { candidateListService } from './Recruitment/CandidateList/CandidateListSlice'
import { vendorListService } from './Assets/VendorList/vendorListSlice'
import { addNewVendorService } from './Assets/VendorList/AddVendorDetails/addVendorDetailsSlice'
import { changeReporteesService } from './Settings/ChangeReportees/changeReporteesSlice'
import { ManufacturerListService } from './Assets/ManufacturerList/ManufacturerSliceList'
import { assetsWarrantyListService } from './Assets/AssetWarrantyReport/assetsWarrantyReportSlice'
import { ProductTypeListService } from './Assets/ProductTypeList/ProductTypeSlice'
import { categoryListService } from './ExpenseManagement/Category/expenseCategoryListSlice'
import { addNewCategoryService } from './ExpenseManagement/Category/AddNewExpenseCategory/addNewExpenseCategorySlice'
import { assetListService } from './Assets/AssetList/AssetListSlice'
import { assetTransactionListService } from './Assets/AssetTransactionList/assetTransactionListSlice'
import { changeAssetStatusService } from './Assets/AssetList/ChangeStatus/ChangeStatusSlice'
import { productSpecificationListService } from './Assets/ProductSpecificationList/ProductSpecificationListSlice'
import { recruitmentHistoryServices } from './MyProfile/RecruitmentHistory/recruitmentHistorySlice'
import { addProductService } from './Assets/ProductSpecificationList/AddNewProduct/AddProductSpecificationListSlice'
import { AddAssetListService } from './Assets/AssetList/AddAssetListSlice'
import { CopyAddAssetService } from './Assets/AssetList/CopyAddAssetSlice'
import { SeparationServices } from './MyProfile/Separation/SeparationSlice'
import { companiesListService } from './Recruitment/CompaniesList/CompaniesListSlice'
import { creditCardListService } from './ExpenseManagement/CreditCardList/creditCardListSlice'
import { candidateOfferService } from './Recruitment/CandidateOffer/CandidateOfferSlice'
import { subCategoryListService } from './ExpenseManagement/Sub-Category/expenseSubCategoryListSlice'
import { upComingJoiningListService } from './Recruitment/UpComingJoinList/upComingJoinListSlice'
import { expenseFormService } from './ExpenseManagement/ExpenseForm/expenseFormSlice'
import { interviewStatusReportServices } from './Recruitment/InterviewStatusReport/InterviewStatusReportSlice'
import { userRolesConfigurationsServices } from './Settings/UserRolesConfiguration/UserRolesConfigurationSlice'
import { paymentListService } from './ExpenseManagement/PaymentList/PaymentListSlice'
import { ChecklistServices } from './Checklist/ChecklistSlice'
import { expensesTimeLineService } from './ExpenseManagement/ExpensesList/ExpensesTimeLine/expensesTimeLineSlice'
import { expensesListService } from './ExpenseManagement/ExpenseList/expensesListSlice'
import { expenseYearlyReportService } from './ExpenseManagement/ExpenseYearlyReport/expenseYearlyReportSlice'
import { sectionListServices } from './Sections/SectionsSlice'
import { remittanceService } from './Invoicing/RemittanceDetails/remittanceDetailsSlice'
import { adderessListService } from './Invoicing/AdderessList/AddressListSlice'
import { clientInvoiceReportService } from './Invoicing/ClientInvoiceReport/clientInvoiceReportSlice'
import { invoicelocationService } from './Invoicing/LocationList/addInvoiceLocationlistSlice'
import { addBankService } from './Invoicing/AddBankList/addBankListSlice'
import { addInvoiceServices } from './ProjectManagement/Project/ProjectView/Invoices/AddInvoice/addInvoiceSlice'
import { addTaxListService } from './ProjectManagement/Project/ProjectView/Invoices/addTaxSlice'
import { countryListService } from './ProjectManagement/Project/ProjectView/Invoices/CountryList/countryListSlice'
import { ProjectNumbersService } from './ProjectManagement/Project/ProjectView/ProjectNumbers/ProjectNumbersSlice'
import { invoicingDiscussionService } from './ProjectManagement/Project/ProjectView/Invoices/invoicingDiscussionSlice'
import { invoiceAuditLogService } from './Invoicing/Invoices/InvoiceAuditLog/invoiceAuditLogSlice'
import { invoiceTimeLineService } from './ProjectManagement/Project/ProjectView/Invoices/invoiceTimeLineSlice'
import { addCurrencyService } from './Invoicing/Invoices/Settings/addCurrencySlice'
import { invoiceAuditReportService } from './Invoicing/InvoiceAuditReport/invoiceAuditReportSlice'
import { projectMilestonesListService } from './Invoicing/ProjectMilestones/projectMilestonesSlice'
import { invoiceListService } from './Invoicing/Invoices/invoiceListSlice'
import { invoiceSendReminderService } from './Invoicing/Invoices/InvoicesSendReminder/invoiceSendReminderDetailsSlice'
import { invoiceSummaryService } from './Invoicing/InvoiceSummary/invoiceSummarySlice'
import { invoicesReportService } from './Invoicing/InvoiceReport/invoicesReportListSlice'
import { editProjectCreationRequestService } from './ProjectManagement/ProjectCreationRequests/EditProjectCreationRequest/editProjectCreateRequestSlice'
import { employeeProfileViewServices } from './MyProfile/EmployeeProfile/employeeViewProfileSlice'
import { profileService } from './MyProfile/MyProfileSlice'
import { shortFallService } from './ShortFall/shortFallSlice'
import { internDetailsService } from './EmployeeDirectory/InternDetails/internDetailsSlice'
import { SidebarMenuSliceService } from './SidebarMenu/sidebarMenuSlice'
import { candidateInterviewListService } from './Recruitment/CandidateList/CandidateInterviewListSlice'
import { accessCardDetailsService } from './EmployeeDirectory/AccessCardDetails/accessCardDetailsSlice'
import { appraisalLettersService } from './Finance/AppraisalLetters/AppraisalLettersSlice'
import { resumeMatcherService } from './Recruitment/ResumeMatcher/resumeMatcherSlice'
import { lateArrivalReportService } from './TimeAndAttendance/LateArrivalReport/lateArrivalReportSlice'
import { attendanceRegularizationService } from './TimeAndAttendance/AttendanceRegularization/attendanceRegularizationSlice'
import { employeeApplyLateService } from './Leaves/ApplyLateArrival/employeeApplyLateSlice'
import { pmoConfigurationService } from './ProjectManagement/PmoConfigurationRenamed/PmoConfigurationSlice'
import { formSixteenUploadService } from './Finance/FormSixteenUpload/FormSixteenUploadSlice'
import { formSixteenDownloadService } from './Finance/FormSixteenDownload/FormSixteenDownloadSlice'
import { complianceService } from './ComplianceReminderSlice/ComplianceReminderSlice'
import { upcomingComplianceService } from './Dashboard/upComingComplianceSlice'
import { projectClosureChecklistService } from './ProjectManagement/Project/ProjectView/ProjectClosure/projectClosureChecklistSlice'
import { OnContractService } from './Dashboard/onContractSlice'
import { interviewerConfigurationService } from './Recruitment/InterviewerConfigration/interviewerConfigurationSlice'
import { vendorResetService } from './vendorresetPswd/vendorResetSlice'
import { sowService } from './ProjectManagement/Project/ProjectView/SOW/sowSlice'
import { observationService } from './Performance/Observation/observationSlice'
import { festivalUploadService } from './Settings/FestivalManagement/FestivalUploadSlice'

export const reduxServices = {
  app: appService,
  sidebarMenu: SidebarMenuSliceService,
  authentication: authenticationService,
  category: categoryService,
  skill: skillService,
  employeeList: employeeListService,
  profileHistory: profileHistoryService,
  personalInformation: personalInfoService,
  userRolesConfigurations: userRolesConfigurationsServices,
  employeeDesignation: employeeDesignationListService,
  newEmployee: addNewEmployeeService,
  employeeCertifications: employeeCertificateService,
  employeeQualifications: employeeQualificationService,
  employeeQualificationCategory: qualificationCategoryService,
  profile: profileService,
  basicInformation: basicInformationService,
  generalInformation: generalInformationService,
  employeeSkill: employeeSkillServices,
  employeeReviews: employeeReviewsService,
  employeeProjects: employeeProjectsService,
  shiftConfiguration: shiftConfigurationService,
  employeeReportees: employeeReporteesService,
  certificateList: certificateListService,
  employeeAssets: employeeAssetsService,
  certificateType: certificateTypeService,
  employeeReports: employeeReportService,
  employeeDesignationReports: employeeDesigationReportService,
  visaList: visaListService,
  EmployeeHandbook: EmployeeHandbookService,
  ShowHandbook: ShowHandbookService,
  NewYearPopup: newYearPopupService,
  employeeAttendanceReport: attendanceReportService,
  shortFall: shortFallService,
  internDetails: internDetailsService,
  userAccessToFeatures: userAccessToFeaturesService,
  employeeHandbookSettings: employeeHandbookSettingService,
  employeeLeaveSettings: employeeLeaveSettingsService,
  technology: technologyService,
  country: countryService,
  timeInOfficeReport: timeInOfficeReportService,
  vpnAttendance: vpnAttendanceService,
  hiveActivityReport: hiveActivityReportService,
  employeeMailConfiguration: employeeMailConfigurationService,
  addNewMailTemplate: addTemplateService,
  employee: employeeService,
  employeeApplyLeave: employeeLeaveApplyServices,
  scheduledInterviews: scheduledInterviewsService,
  addNewMailTemplateType: mailTemplateTypeService,
  myAttendance: myAttendanceService,
  leaveReport: leaveReportService,
  ticketReport: ticketReportService,
  projectManagement: projectManagementService,
  allocateEmployee: allocateEmployeeService,
  clients: clientsService,
  addClient: addNewClientService,
  clientInformation: clientInformationService,
  employeeLeaveSummary: leaveSummaryService,
  tickets: myTicketsService,
  ticketApprovals: ticketApprovalsService,
  raiseNewTicket: createNewTicketService,
  jobOpenings: jobVacanciesService,
  scheduleInterviewComments: PendingInterviewCommentsService,
  birthdaysList: birthdaysListService,
  anniversaryList: anniversaryListService,
  upcomingBirthdays: upcomingBirthdaysService,
  upcomingServiceAnniversaries: upcomingServiceAnniversaryService,
  holidays: holidaysService,
  earnedLeaves: earnedLeavesService,
  weeklyTimeInOffice: weeklyTimeInOfficeService,
  trainingsAndEvents: trainingsAndEventsService,
  employeeProbationPeriod: provisionPeriodService,
  employeeAchievements: employeeAchievementsService,
  updateTicket: updateTicketService,
  bookingList: bookingListService,
  eventTypeList: eventTypeListService,
  addLocationList: addLocationListService,
  newBooking: newBookingService,
  employeeAllocationReport: employeeAllocationSliceService,
  addTrackerLists: addTrackerListService,
  eventList: eventListService,
  roomLists: roomListService,
  searchEmployee: employeeSearchService,
  assignTemplate: assignTemplateService,
  ticketConfiguration: ticketConfigurationService,
  appraisalConfigurations: appraisalCycleService,
  submitViewResignation: submitViewResignationServices,
  addConfigurations: addConfigurationService,
  projectReport: projectReportsService,
  newEvent: newEventService,
  leaveApprovals: leaveApprovalsService,
  itDeclarationForm: itDeclarationFormService,
  paySlips: paySlipsService,
  insurance: insuranceService,
  appraisalLetters: appraisalLettersService,
  panDetails: panDetailService,
  bankDetails: bankDetailService,
  resignationList: resignationListService,
  employeeAccount: employeeAccountService,
  itDeclarationList: itDeclarationListService,
  investmentCheckList: investmentCheckListService,
  payrollManagement: payrollManagementService,
  achieverList: achieverListService,
  addAchiever: addAchieverServices,
  commonAchievements: commonAchievementsService,
  nomineeList: nomineeListService,
  addNominee: addNomineeService,
  projectCreationRequest: projectCreationRequestService,
  projectViewDetails: projectViewService,
  projectTimeLine: projectTimeLineService,
  projectChangeRequest: changeRequestService,
  projectMileStone: mileStoneService,
  projectInvoices: invoicesService,
  projectInvoiceVersions: invoiceVersionsService,
  projectTailoring: projectTailoringService,
  projectTimeSheet: projectHiveActivityReportService,
  projectClosureChecklist: projectClosureChecklistService,
  projectProposals: projectProposalsService,
  projectNotes: projectNotesService,
  addProjectCreationRequest: addProjectCreationRequestService,
  editProjectCreationRequest: editProjectCreationRequestService,
  initiateCycle: initiateCycleService,
  myKRAs: myKRAsService,
  myReview: myReviewService,
  leadershipEnrollmentList: leadershipEnrollmentListService,
  leadershipEnrollmentForm: leadershipEnrollmentFormService,
  pipList: pipListService,
  reviewList: reviewListServices,
  KRA: KRAService,
  appraisalTemplate: appraisalTemplateService,
  projectStatus: projectStatusService,
  processArea: processAreaService,
  addNewAuditForm: addNewAuditService,
  sqaAuditReport: sqaAuditReportService,
  notification: notificationService,
  jobVacancies: jobOpeningsService,
  vendorList: vendorListService,
  addNewVendor: addNewVendorService,
  changeReportees: changeReporteesService,
  intervieweeDetails: intervieweeDetailsService,
  candidateList: candidateListService,
  candidateInterviewList: candidateInterviewListService,
  ManufacturerList: ManufacturerListService,
  ProductTypeList: ProductTypeListService,
  assetList: assetListService,
  assetsWarrantyList: assetsWarrantyListService,
  changeStatus: changeAssetStatusService,
  categoryList: categoryListService,
  addNewCategory: addNewCategoryService,
  assetTransactionList: assetTransactionListService,
  productSpecificationList: productSpecificationListService,
  recruitmentHistory: recruitmentHistoryServices,
  addNewProduct: addProductService,
  addAssetList: AddAssetListService,
  copyAddAsset: CopyAddAssetService,
  Separation: SeparationServices,
  companiesList: companiesListService,
  creditCardList: creditCardListService,
  addNewCandidate: candidateOfferService,
  subCategoryList: subCategoryListService,
  upComingJoinList: upComingJoiningListService,
  expenseForm: expenseFormService,
  interviewStatusReport: interviewStatusReportServices,
  // expenseForm: expenseFormService,
  paymentList: paymentListService,
  Checklist: ChecklistServices,
  expensesTimeLine: expensesTimeLineService,
  expensesList: expensesListService,
  expenseYearlyReport: expenseYearlyReportService,
  sectionList: sectionListServices,
  remittanceList: remittanceService,
  adderessList: adderessListService,
  clientInvoiceReport: clientInvoiceReportService,
  addInvoicelocation: invoicelocationService,
  addBankList: addBankService,
  addInvoice: addInvoiceServices,
  addTaxList: addTaxListService,
  countryList: countryListService,
  invoiceDiscussion: invoicingDiscussionService,
  addInvoiceAuditLog: invoiceAuditLogService,
  projectNumbers: ProjectNumbersService,
  invoiceHistory: invoiceTimeLineService,
  addCurrency: addCurrencyService,
  invoiceAuditReport: invoiceAuditReportService,
  projectMilestonesReport: projectMilestonesListService,
  invoiceList: invoiceListService,
  invoiceSendReminder: invoiceSendReminderService,
  invoiceSummary: invoiceSummaryService,
  invoicesReport: invoicesReportService,
  employeeProfileView: employeeProfileViewServices,
  accessCardDetails: accessCardDetailsService,
  lateArrivalReport: lateArrivalReportService,
  attendanceRegularization: attendanceRegularizationService,
  employeeApplyLate: employeeApplyLateService,
  resumeMatcher: resumeMatcherService,
  pmoConfiguration: pmoConfigurationService,
  formSixteenUpload: formSixteenUploadService,
  formSixteenDownload: formSixteenDownloadService,
  ComplianceReminder: complianceService,
  UpcomingCompliances: upcomingComplianceService,
  onContractPeriod: OnContractService,
  interviewerConfiguration: interviewerConfigurationService,
  VendorReset: vendorResetService,
  projectSow: sowService,
  observation: observationService,
  festivalService: festivalUploadService,
}
